import { FC } from 'react';

import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';

import sharedStyles from './styles/shared.scss';

type Props = {
    type?: 'primary' | 'transparent';
    fullWidth?: boolean;
    disabled?: boolean;
};

const IFramedPromoPartnershipStartShoppingCta: FC<Props> = ({
    type = 'primary',
    fullWidth,
    disabled,
}) => {
    return (
        <Button
            href="/"
            target="_parent"
            dataTn="promo-partnership-no-promo-button"
            className={sharedStyles.button}
            type={type}
            fullWidth={fullWidth}
            disabled={disabled}
        >
            <FormattedMessage
                id="iFramedpromoPartnership.IFramedPromoPartnershipNoPromoCode.cta"
                defaultMessage="Start Shopping"
            />
        </Button>
    );
};

export default IFramedPromoPartnershipStartShoppingCta;
